const ROUTES = {
	HOME: '/',
	ADDRESS: '/address',
	SHOW_MAP: '/show-map',
	SHOW_DATA: '/show-data',
	ORGANISATION: '/organisation',
	UNAUTHORIZED: '/UNAUTHORIZED'
};

export default ROUTES;